import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {campaignBaseInitialState} from './campaignBase.config';
import {CampaignWorkflowDataByStep} from 'common/src/modules/campaignWorkflow/campaignWorkflow.types';
import {SlimUser} from 'common/src/modules/users/users.types';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {SocialCampaignFlowStatus} from 'common/src/modules/externalAds/externalAds.types';
import {CampaignBaseState} from './campaignBase.types';
import campaignIssuesReducer from '../campaignIssues/campaignIssues.slice';
import campaignCommentsReducer from '../campaignComments/campaignComments.slice';
import {CampaignIntegration} from 'common/src/modules/campaignIntegrations/campaignIntegrations.types';

const campaignPageSlice = createSlice({
  name: BreadcrumbName.CampaignPage,
  initialState: campaignBaseInitialState,
  reducers: {
    resetCampaignBase: () => campaignBaseInitialState,
    resetCampaignIntegrations: (state) => {
      state.connectedCampaigns = [];
      state.integratedServices = [];
      state.areIntegrationsLoading = false;
    },
    updateCampaignWorkflowDataByStep: (
      state,
      action: PayloadAction<CampaignWorkflowDataByStep | null>,
    ) => {
      state.campaignWorkflowDataByStep = action.payload;
    },
    updateCampaignWorkflowMappedUsers: (state, action: PayloadAction<Record<string, SlimUser>>) => {
      state.mappedUsers = action.payload;
    },
    updateSocialCampaignFlowStatus: (state, action: PayloadAction<SocialCampaignFlowStatus>) => {
      state.socialCampaignFlowStatus = action.payload;
    },
    updateIsSocialCampaignPartialActive: (state, action: PayloadAction<boolean>) => {
      state.isSocialCampaignPartialActive = action.payload;
    },
    updateConnectedCampaigns: (state, action: PayloadAction<CampaignIntegration[]>) => {
      state.connectedCampaigns = action.payload;
    },
    updateIntegratedServices: (state, action: PayloadAction<CampaignIntegration[]>) => {
      state.integratedServices = action.payload;
    },
    updateAreIntegrationsLoading: (state, action: PayloadAction<boolean>) => {
      state.areIntegrationsLoading = action.payload;
    },
  },
});

export const {
  resetCampaignBase,
  updateCampaignWorkflowDataByStep,
  updateCampaignWorkflowMappedUsers,
  updateSocialCampaignFlowStatus,
  updateIsSocialCampaignPartialActive,
  updateConnectedCampaigns,
  updateIntegratedServices,
  updateAreIntegrationsLoading,
  resetCampaignIntegrations,
} = campaignPageSlice.actions;

export default function campaignBaseReducer(state: CampaignBaseState, action: PayloadAction) {
  const baseState = campaignPageSlice.reducer(state, action);
  const issues = campaignIssuesReducer(state?.issues, action);
  const comments = campaignCommentsReducer(state?.comments, action);

  return {...baseState, issues, comments};
}
